import { getApiUrl } from "src/common/api/getUrl";
import { dataParser } from "src/common/dataParser";
import { rest } from "src/common/rest";

import { ZCatalogTreeItem, zCatalogTreeItem } from "./ZCatalogTreeItem";

export const loadCatalogBranch = async (
  catalogId: string,
  classifierId?: string,
  parentId?: string,
): Promise<ZCatalogTreeItem[]> => {
  const path = getApiUrl(`/core/tree/catalog/${catalogId}/children`);
  const params: Record<string, string> = {};
  if (classifierId) params.classifierId = classifierId;
  if (parentId) params.parentId = parentId;
  const resp = await rest.get(path, { params });
  return dataParser(
    () => zCatalogTreeItem.array().parse(resp.data),
    "loadCatalogBranch",
  );
};
